module.exports = __webpack_public_path__ + "static/media/call_start.1b455d3e.png";